import React from 'react';
import { Route } from 'react-router-dom';
import CarsIcon from '@mui/icons-material/DirectionsCar';
import CategoryIcon from '@mui/icons-material/Category';
import LabelIcon from '@mui/icons-material/Label';
import CarsList from '../pages/cars/CarsList';
import CategoryList from '../pages/categories/CategoryList';
import { RoutePathProps } from '../../../AppRoutes/types';
import CarInfo from '../pages/cars/CarInfo';
import { addChildRoute } from '../../../AppRoutes/utils';
import AddCar from '../pages/cars/AddCar';
import EditCar from '../pages/cars/EditCar';
import BrandsList from '../pages/brands/BrandsList';
import AddBrand from '../pages/brands/AddBrand';
import EditBrand from '../pages/brands/EditBrand';
import CategoryInfo from '../pages/categories/CategoryInfo';
import AddCategory from '../pages/categories/AddCategory';
import EditCategory from '../pages/categories/EditCategory';
import Configuration from '../pages/Configuration';


const cars: RoutePathProps = {
  name: 'cars',
  path: '/cars',
  label: 'Cars',
  visibleInNav: true,
  icon: CarsIcon,
  requiredPermission:'car:list',
  children: [
    {
      name: 'carInfo',
      path: '/:id', // relative to /cars
      label: 'Car Info',
      icon: CarsIcon,
      requiredPermission:'car:read'
    },
    {
      name: 'addCar',
      path: '/addCar', // relative to /cars
      label: 'Add Car',
      icon: CarsIcon,
      requiredPermission:'car:create'
    },
    {
      name: 'editCar',
      path: '/editCar/:id', // relative to /cars
      label: 'Edit Car',
      icon: CarsIcon,
      requiredPermission:'car:update'
    },
  ],
};

const categories: RoutePathProps = {
  name: 'categories',
  path: '/categories',
  label: 'Categories',
  visibleInNav: true,
  icon: CategoryIcon,
  requiredPermission:'category:list',
  children: [
    {
      name: 'categoryInfo',
      path: '/:id', // relative to /categories
      label: 'Category Info',
      icon: CategoryIcon,
      requiredPermission:'category:read'
    },
    {
      name: 'addCategory',
      path: '/addCategory', // relative to /categories
      label: 'Add Category',
      icon: CategoryIcon,
      requiredPermission:'category:create'
    },
    {
      name: 'editCategory',
      path: '/editCategory/:id', // relative to /categories
      label: 'Edit Category',
      icon: CategoryIcon,
      requiredPermission:'category:update'
    },
  ],
};

const brands: RoutePathProps = {
  name: 'brands',
  path: '/brands',
  label: 'Brands',
  visibleInNav: true,
  icon: LabelIcon,
  requiredPermission:'brand:list',
  children: [
    {
      name: 'addBrand',
      path: '/addBrand', // relative to /categories
      label: 'Add Brand',
      icon: LabelIcon,
      requiredPermission:'brand:create'
    },
    {
      name: 'editBrand',
      path: '/editBrand/:id', // relative to /categories
      label: 'Update Brand',
      icon: LabelIcon,
      requiredPermission:'brand:update'
    },
  ],
};


const configuration: RoutePathProps = addChildRoute(
  {
    name: 'configuration',
    path: '/configuration',
    label: 'Configuration',
    visibleInNav: true,
    icon: CategoryIcon,
    dummy: true,
    children: [cars, categories, brands],
    requiredPermission:'configuration:list'
  },
  { cars, categories, brands }
);

// console.log(
//   'Merged paths:',
//   configuration.children?.[0].path, // /configuration/cars
//   configuration.children?.[0].children?.[0].path, // /configuration/cars/:carId
//   configuration.children?.[0].children?.[1].path  // /configuration/cars/addCar
// );

const ConfigurationRoutes = (
  <>
    <Route path={configuration.path} element={<Configuration />} />

    <Route path={configuration.children?.[0].path} element={<CarsList />} />
    <Route path={configuration.children?.[0].children?.[0].path} element={<CarInfo />} />
    <Route path={configuration.children?.[0].children?.[1].path} element={<AddCar />} />
    <Route path={configuration.children?.[0].children?.[2].path} element={<EditCar />} />

    <Route path={configuration.children?.[1].path} element={<CategoryList />} />
    <Route path={configuration.children?.[1].children?.[0].path} element={<CategoryInfo />} />
    <Route path={configuration.children?.[1].children?.[1].path} element={<AddCategory />} />
    <Route path={configuration.children?.[1].children?.[2].path} element={<EditCategory />} />

    <Route path={configuration.children?.[2].path} element={<BrandsList />} />
    <Route path={configuration.children?.[2].children?.[0].path} element={<AddBrand />} />
    <Route path={configuration.children?.[2].children?.[1].path} element={<EditBrand />} />

  </>
);

export const configurationPaths = [configuration];
export default ConfigurationRoutes;
